import { Spin } from "antd";
import { useUser } from "../../../../contexts/UserContext/UserContext";
import isBillingEnabled from "../../../../helpers/billing";
import SubscriptionBilling from "./Billing";
import FreePlanCard from "./FreePlanCard";

// Picks the paid billing page or the Free plan page based on the backend's billing flag.
// Kept separate so Billing.jsx makes none of its API calls in FREE mode.
const BillingGate = (props) => {
    const { myCompanyData } = useUser();

    if (!myCompanyData) {
        return (
            <div style={{ textAlign: "center", padding: "50px" }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!isBillingEnabled(myCompanyData)) {
        return <FreePlanCard />;
    }

    return <SubscriptionBilling {...props} />;
};

export default BillingGate;
